import React, { useEffect } from "react";
import MainMenus from "../../common/menus";
// import TopHeader from "../contacts/topheader";
import MeetingsLeftsideBars from "./leftsidebar";
import CalederScreen from "./meetingWidgets/calenderView";
import MeetingDetailsScreen from "./meetingWidgets/meetingDetails";
import MeetingStartScreen from "./meetingWidgets/meetingStart";
import ScheduleMeetingScreen from "./meetingWidgets/scheduleMeeting";
import styles from "./scss/chatframe.module.scss";
import RecordVideosideBars from "./meetingWidgets/recordvideoScreen";
import MeetingStandupVideo from "./meetingWidgets/recordedMeetings";
//import VideoCallScreenRight from "../call/callsDialPad/imcomingVideocall";
import TopHeader from "../chat/chatsection/topheader";
import ToastLeft from "../../shared/widgets/toastScreenleft";
import { useSelector } from "react-redux";
import videoEncrypt from "../../styles/images/videoencrypt.svg"
//import VideoCallScreenRight from "../call/callsDialPad/imcomingVideocall";
import { storeWindowState } from "../../base/meetingService/meetingStoreServices";
import {  initialStateModel, startaScreenModel } from "../../models/model";
import InnerEncryption from "../../common/innerEncryption";
import { Cookie, Logout } from "../../base/utils";
import { SocketChatService } from "../../base/socketChatService";
import { unregister } from "../../base/callService/callService";
import { useHistory } from "react-router";
import { totalTabBatchcount, userInfo } from "../../base/socketChatService/utils";
import { Meetingnotifications } from "../videonotifications/Meetingnotifications";
import { handelMeetingNotification } from "../../base/socketChatService/newChat";
import CCToast from "../../shared/widgets/ccToast";
import NoRecording from "./leftsidebar/noRecording";
import SmartEpisodesScreen from "./meetingWidgets/smartepisode";
import RecordPlayListsideBars from "./meetingWidgets/recordPlayList";
export default function MeetingMainFrame() {

 const history = useHistory();

  let { meetingReducer , toastReducer}: any = useSelector((state: any) => state);

  let { currentWindowState,ccToast,videoRecordingList,getRecordListInput } = meetingReducer || [];//store.getState().meetingReducer || [];
  let { isLeftToast } = toastReducer ;//store.getState().toastReducer;
  const { startingScreenLoader}: startaScreenModel =
    useSelector((state: initialStateModel) => state.startingScreenReducer);
    const initalState: any = useSelector((state: any) => state.serverDisconnectReducer);

  useEffect(() => {
    storeWindowState("mainPage");
    let chromeCount:any = totalTabBatchcount();
    document.title= chromeCount > 0 ?"Worktual Web Application ("+ chromeCount +")" : "Worktual Web Application";

  }, [])
  useEffect(()=>{
    if (toastReducer.meetingNotify.title !== undefined) {
      //console.log('toastReducer.meetingNotify -- > -- ', toastReducer.meetingNotify);
      //openNotification('topRight', toastReducer.meetingNotify);
     Meetingnotifications('topRight', toastReducer.meetingNotify, history);
     handelMeetingNotification({});
    }
  },[toastReducer.meetingNotify])

  useEffect(()=>{
    if(initalState?.serverDisconnect){
      try{
     // Logout().then(()=>{
        const chatService = new SocketChatService(userInfo().fromID, userInfo().domainId);
        if(chatService.socketConnection){
          chatService.socketConnection.closeConnection();
          }
        chatService.destroy();
        chatService.eventEmit = null;
        chatService.socketConnection = null;
        Cookie.clear();
        localStorage.clear();
        sessionStorage.clear();
        SocketChatService._instance = null;
        unregister();
        history.push("/login");
        history.replace("/login")
      } catch(error:any){
        console.log(error,"error")
      }
      //});
    }
  },[initalState?.serverDisconnect])


  return (
    <>
      {(startingScreenLoader) && <InnerEncryption fromComponent={"Video"} icon={videoEncrypt} />}

      <div className={styles.mainframe}>
        <div className={styles.framemenu}>
          <MainMenus></MainMenus>
        </div>
        <div className={`${styles.frameleftsidebar}
         ${styles.hideframeleftsidebar}`}>
          <div className={styles.mobilemenu}><span className="icon_close"></span></div>
          {currentWindowState !== 'recordedMeeting' &&  <MeetingsLeftsideBars />}

          {currentWindowState === 'recordedMeeting' && 
           <RecordVideosideBars />}
        </div>
        <div className={styles.framemain}>
          <div className={styles.frameheader}>
            <div className={styles.mobilemenu}>
              <span className="icon_listview menuicons"></span>
            </div>
            <TopHeader></TopHeader>
          </div>
          <div className={`${styles.framemainsection} scroller`}>
            
            {/********************** MEETINGS MAIN SCREEN ********************/}
            {currentWindowState === 'mainPage' &&
              <>
                <CalederScreen />
                <MeetingStartScreen />
              </>
            }

            {/********************** MEETINGS MAIN SCREEN ********************/}

            {/********************** MEETINGS DETAILS SCREEN ********************/}

            {(currentWindowState === 'meetingDetails' || currentWindowState === 'templateDetails') &&
              <MeetingDetailsScreen />
            }
                       {
            currentWindowState ==="recordedVideo" && <SmartEpisodesScreen/>
           }

            {/* {
            currentWindowState ==="playList" && <RecordPlayListsideBars/>
           } */}

            {/* {
              (currentWindowState === 'editMeeting' || currentWindowState === 'useTemplate') &&
              <EditMeeting />
            } */}

            {/********************** MEETINGS DETAILS SCREEN ********************/}


            {/* ********************* SCHEDULE MEETINGS CREATE SCREEN ******************* */}

            {(currentWindowState === 'createMeeting' || currentWindowState === 'editMeeting'
            ||currentWindowState ==='reschedule'  || currentWindowState === 'useTemplate' || currentWindowState === 'templateList') &&
              <ScheduleMeetingScreen />
            }

            {/********************** SCHEDULE MEETINGS CREATE SCREEN ********************/}

            {/* ********************* Recorded MEETINGS DETAILS SCREEN ******************* */}

            {currentWindowState === 'recordedMeeting' && videoRecordingList?.length > 0 && 
              <MeetingStandupVideo />
            }

            {currentWindowState === 'recordedMeeting' && videoRecordingList?.length === 0 && 
              <NoRecording />
            }
            
            {/********************** Recorded MEETINGS DETAILS SCREEN ********************/}

          </div>
        </div>
      </div>
      {/* <div className="uplodingnotification">
        <div className="uploadinginnercon">
          <div className="tophednoti" >
            <span className="icon_Preview-minus"></span>
            <span className="icon_close"></span>
          </div>
          <div className="tophednotiheadersec">
            <h3>Uploading Recording to UnifiedRing Cloud </h3>
          </div>
          <div className="middleprogres">
            <div className="progress">
              <div className="progressbar" style={{ width: '26%' }}>
              </div>
            </div>
            <div className="txtreduces"><span className="">26%</span></div>
          </div>
          <div className="footerbtnsec">
            <div className="lftupbtn">
              <Link to="/">Completed!</Link>
              <Link to="/">View Meeting Recordings</Link>
            </div>
            <div className="rightupbtn">
              <button className="btnupdtrigt">Stop Uploading</button>
            </div>
          </div>
        </div>
      </div> */}

      {/* <VideoCallScreenRight /> */}
      {isLeftToast && <ToastLeft />}
      {ccToast && <CCToast/>}
    </>
  );
};

